import { ref, computed } from 'vue'

const showSnackbar = ref(false)
const snackbarMessage = ref('')
const snackbarUndoAction = ref(false)
const snackbarWiggleKey = ref(0)
let snackbarTimeout = null
let undoCallback = null

/**
 * Global snackbar composable
 * Provides a centralized way to show snackbar notifications across the app
 */
export function useSnackbar() {
  const show = (message, options = {}) => {
    const alreadyShowingSame = showSnackbar.value && snackbarMessage.value === message

    snackbarMessage.value = message
    snackbarUndoAction.value = options.undo !== undefined ? !!options.undo : false
    undoCallback = options.undo || null
    showSnackbar.value = true

    // If already showing same message, wiggle to draw attention
    if (alreadyShowingSame) {
      snackbarWiggleKey.value = (snackbarWiggleKey.value || 0) + 1
      setTimeout(() => {
        snackbarWiggleKey.value = 0
      }, 450)
    }

    // Clear any existing timeout
    if (snackbarTimeout) {
      clearTimeout(snackbarTimeout)
    }

    // Auto-hide after duration (default 3 seconds, or 5 seconds if undo available)
    const duration = options.duration || (options.undo ? 5000 : 3000)
    snackbarTimeout = setTimeout(() => {
      hide()
    }, duration)
  }

  const hide = () => {
    showSnackbar.value = false
    if (snackbarTimeout) {
      clearTimeout(snackbarTimeout)
      snackbarTimeout = null
    }
  }

  const handleUndo = () => {
    if (undoCallback && typeof undoCallback === 'function') {
      undoCallback()
    }
    hide()
  }

  return {
    showSnackbar: computed(() => showSnackbar.value),
    snackbarMessage: computed(() => snackbarMessage.value),
    snackbarUndoAction: computed(() => snackbarUndoAction.value),
    snackbarWiggleKey: computed(() => snackbarWiggleKey.value),
    show,
    hide,
    handleUndo
  }
}
